

export const URL_DEV_MODELS = "/dev/basic/devModels";           // 设备型号列表
//export const URL_DEV_STR_STATS = "/dev/basic/storageStats";     // 设备仓储状态列表
//export const URL_DEV_ACT_STATS = "/dev/basic/activeStats";      // 设备激活状态列表
//export const URL_DEV_ALT_STATS = "/dev/basic/allotStats";       // 设备调拨状态列表

export const URL_FILE_UPLOAD = "/pub/file/fileUpload";          // 上传文件

export const URL_AREAS = "/pub/areas";                          // 通过PID获取区域列表(缺省PID为1 获取省份列表)
export const URL_AREAS_PROV_CITY = "/pub/areasProvCity";        // 获取省市列表

export const URL_AGENT_LEVELS = "/agent/basic/agentLevels";     // 代理商等级列表
export const URL_AGENT_STATUSES = "/agent/basic/agentStatuses";     // 代理商状态列表
export const URL_AGENT_NATURES = "/agent/basic/agentNatures";   // 代理商性质列表
export const URL_AGENT_FROMS = "/agent/basic/agentFroms";       // 代理商来源列表
export const URL_AGENT_NAME = "/agent/basic/agentName";       //


export const URL_BANK_CNAPS_LIST_PAGE = "/system/paybank/cnaps/list";
export const URL_BANK_CNAPS_UPDATE = "/system/paybank/cnaps/updateCnapsNameByCode"
export const URL_BANK_ACC_TYPES = "/pub/bank/accTypes";         // 账户类型列表
export const URL_BANK_BANK_LIST = "/pub/bank/bankList";         //
export const URL_BANK_PROV_LIST = "/pub/bank/provList";         //
export const URL_BANK_CITY_LIST = "/pub/bank/cityList";         //
export const URL_BANK_CNAPS_LIST = "/pub/bank/cnapsList";       //
export const URL_BANK_CNAPS = "/pub/bank/cnapsInfo";       //
export const URL_DATA_MCH_BUSINESSCATEGORY = "/pub/data/mch/businessCategory";       //

export const URL_DATA_USER_BASE_PRORATE = "/pub/data/user/userProductRate";       //
export const URL_DATA_USER_BASE_PRORATE_BY_USER = "/pub/data/user/userProductRateByUser";       //

export const URL_DATA_PURBATNO = "/pub/data/uniqueCode/purBatNo";         //
export const URL_DATA_ALLOTORDERNO = "/pub/data/uniqueCode/allotOrderNo";         //

export const URL_PUB_FILEINFO_USERID = "/pub/file/fileInfoByUserId";   //

export const MAIN_BOARD_WEEK_ALL = "/rpt/mainBoard/amountWeek";
export const MAIN_BOARD_DATE_SCOPE_ALL = "/rpt/mainBoard/amountDateScope";
export const MAIN_BOARD_AMOUNT_SCOPE_ALL = "/rpt/mainBoard/amountScope";
export const MAIN_BOARD_NUM_COUNT = "/rpt/mainBoard/numCount";

export const AGENT_ACC_INFO = "/agent/basic/agentAccInfo";

export const URL_IMG_OCR_BIZ = "/ocr/bizLicense";
export const URL_IMG_OCR_BANK_CARD = "/ocr/bankCard";
export const URL_IMG_OCR_ID_CARD = "/ocr/idCard";

export const URL_CREATE_SYNC_STATUS = "/mch/channel/syncStatus";       //
export const URL_CONFIG_REALNAME_APPLY_QUERY = "/mch/channel/realname/applyAndQuery";       //
export const URL_CONFIG_CHANNEL_BIND_WXAPPID = "/mch/channel/bind/wxappid";       //
